export function TextFieldValidator(input: string) {
    return input.length <= 50; //length check
}

//const strictFormat: RegExp = /[`!@#$�%^&*()+\-_=\[\]{};':"\\|,.<>\/?~]/;
const strictFormat: RegExp = /[^a-zA-Z0-9 ]/; //look of any value that is not a standard letter, diget or a space

export function StrictTextFieldValidator(input: string): boolean {
    let valid: boolean = false;

    if (input.length <= 50) //length check
    {
        valid = !strictFormat.test(input); //test looks for any non-standard chars by default
    }

    return valid;
}